import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "video-player" }
const _hoisted_2 = ["poster", "src", "id"]
const _hoisted_3 = ["src"]

import { ref } from 'vue'
import { showToast } from 'vant'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { isFeishu } from '@/utils/feishu'
import { device } from '@/utils/Device'


export default /*@__PURE__*/_defineComponent({
  __name: 'Player',
  props: {
    id: {},
    url: {},
    coverUrl: {},
    boardId: {},
    rollVideoId: {}
  },
  setup(__props: any) {

const props = __props
const { t } = useI18n()
const videoPlayer = ref()
const videoPoster = ref()
const showPlay = ref(true)
const defaultPhoto = require('@/assets/images/defalut_upload_cover.png')
const router = useRouter()
const handlePlay = () => {
  if (!device() && isFeishu) {
    router.push({
      path: '/rollVideo',
      query: {
        sortType: 0,
        id: props.rollVideoId,
        boardId: props.boardId
      }
    })
  } else {
    videoPlayer.value?.play()
    showPlay.value = false
    videoPoster.value.style.display = 'none'
  }
}
// loadedmetadata事件监听器
const onLoadedMetadata = () => {
  showPlay.value = true
  // document.addEventListener('DOMContentLoaded', function() {
  try {
    if (videoPlayer.value) {
      observer.observe(videoPlayer.value)
    }
  } catch (error) {}
  // })
}

const observer = new IntersectionObserver(
  (entries) => {
    if (entries[0].isIntersecting) {
      // showPlay.value = false
    } else {
      if (videoPlayer?.value) {
        videoPlayer?.value.pause()
        videoPoster.value.style.display = 'block'
      }
      showPlay.value = true
    }
  },
  { threshold: 0.5 }
)

const handleVideo = () => {
  if (props.url === '') {
    showToast(t('community_video_loseTip'))
    return
  }
  showPlay.value = false
  // 只能同时播放一个视频
  const videos = Array.from(document.getElementsByTagName('video'))
  const posters = Array.prototype.slice.call(document.getElementsByClassName('poster-wrapper'))
  videos?.forEach((video: HTMLVideoElement, index: number) => {
    video.addEventListener('play', () => {
      pauseAll(index)
    })
  })
  function pauseAll(index: number) {
    videos?.forEach((video: HTMLVideoElement, i: number) => {
      if (i !== index) {
        video.pause()
        posters[i].style.display = 'block'
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("video", {
      class: "player-container-id",
      poster: __props.coverUrl || _unref(defaultPhoto),
      key: __props.id,
      src: __props.url,
      controls: "",
      controlslist: "nodownload noremoteplayback noplaybackrate foobar",
      disablepictureinpicture: "",
      ref_key: "videoPlayer",
      ref: videoPlayer,
      onLoadedmetadata: onLoadedMetadata,
      onPlay: handleVideo,
      id: __props.id,
      playsinline: "",
      "webkit-playsinline": "",
      allowfullscreen: "true"
    }, null, 40, _hoisted_2)),
    _createElementVNode("div", {
      class: "poster-wrapper",
      ref_key: "videoPoster",
      ref: videoPoster,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handlePlay()))
    }, [
      _createElementVNode("img", {
        src: __props.coverUrl || _unref(defaultPhoto),
        alt: ""
      }, null, 8, _hoisted_3),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "play" }, [
        _createElementVNode("i", { class: "iconfont icon-icon_shequzhongxin_bofang" })
      ], -1))
    ], 512)
  ]))
}
}

})